export default "__VITE_ASSET___qMETDLs__"